export default "__VITE_ASSET__a5231f22__"